export const SET_JOB_TAB = 'SET_JOB_TAB';
export const SET_TAB_PAGE = 'SET_TAB_PAGE';
